import "./Header.css";

function Header(){
    return <header className="header">
        <img src="/img/header.png" alt="Org"/>
    </header>
}

export default Header;